import { getInstalledUpiAppsFromStorage } from '../../../utils/installedUpiIntents'
import { getUpiAppConfigByScheme, resolveUpiAppDisplay } from '../../../utils/mf-execution/upiAppConfig'
import { isUpiIntentsFlowEnabled } from '../../../utils/mf-execution/upiIntentsFeature'

export function UpiIntentRedirectModal({
  upiPackageName,
  actionUrl,
}: {
  upiPackageName?: string | null
  actionUrl?: string
}) {
  if (!isUpiIntentsFlowEnabled()) {
    return null
  }

  const { appName, appLogoUrl } = getUpiIntentAppDisplay(upiPackageName, actionUrl)

  return (
    <div className='fixed inset-0 z-[100] flex items-center justify-center bg-black/50 px-8'>
      <div className='w-full max-w-[280px] rounded-2xl bg-white px-8 py-10 flex flex-col items-center text-center shadow-lg'>
        {appLogoUrl ? (
          <img src={appLogoUrl} alt={appName} className='w-12 h-12 object-contain mb-6' />
        ) : (
          <div className='w-12 h-12 mb-6 rounded-lg bg-grey80' />
        )}
        <p className='text-base font-medium text-grey10 leading-snug'>
          Redirecting to
          <br />
          {appName}
        </p>
      </div>
    </div>
  )
}

export function getUpiIntentAppDisplay(
  upiPackageName: string | null | undefined,
  actionUrl: string | undefined
) {
  const installedApps = getInstalledUpiAppsFromStorage()
  const normalizedPackageName = upiPackageName?.toLowerCase() ?? ''

  if (normalizedPackageName) {
    const matchedApp = installedApps.find((app) => {
      const packageName = app?.packageName?.toLowerCase() ?? ''
      const appName = app?.name?.toLowerCase() ?? ''
      return packageName === normalizedPackageName || packageName.includes(normalizedPackageName) || appName === normalizedPackageName
    })

    if (matchedApp) {
      const resolved = resolveUpiAppDisplay(upiPackageName, {
        name: matchedApp.name,
        logoUrl: matchedApp.appLogoUrl,
      })
      return { appName: resolved.name, appLogoUrl: resolved.logoUrl }
    }

    const schemeConfig = getUpiAppConfigByScheme(normalizedPackageName)
    if (schemeConfig) {
      const resolved = resolveUpiAppDisplay(normalizedPackageName)
      return { appName: resolved.name, appLogoUrl: resolved.logoUrl }
    }

    const resolved = resolveUpiAppDisplay(upiPackageName)
    return { appName: resolved.name, appLogoUrl: resolved.logoUrl }
  }

  const scheme = actionUrl?.split(':')[0]?.toLowerCase() ?? ''
  const schemeConfig = getUpiAppConfigByScheme(scheme)
  if (schemeConfig) {
    const matchedByScheme = installedApps.find((app) => app?.packageName?.toLowerCase().includes(scheme))
    const resolved = resolveUpiAppDisplay(matchedByScheme?.packageName ?? scheme, {
      name: schemeConfig.name,
      logoUrl: matchedByScheme?.appLogoUrl,
    })
    return { appName: resolved.name, appLogoUrl: resolved.logoUrl }
  }

  return { appName: 'UPI app', appLogoUrl: '' }
}
